import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Aadhaar generator following Single Responsibility Principle
 */
export class AadhaarGenerator extends BaseGenerator {
  generate() {
    // First digit cannot be 0 or 1
    const firstDigit = this.randomInt(2, 9);
    const remainingDigits = this.randomDigits(10);
    
    const partial = firstDigit + remainingDigits;
    const checksum = ChecksumCalculator.calculateVerhoeffChecksum(partial);
    
    return partial + checksum;
  }
}